import React, { useEffect, useState } from "react";
import "./loginComponent.css";
import loginLogo from "../../assets/images/newLogo.png";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginInputs from "../../commanComponents/inputs/LoginInputs";
import svgData from "../../constants/utilities/svgData";
import { communication } from "../../constants/apis/communication";
import { useMutation } from "react-query";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import Loader from "../../commanComponents/Loader";

export default function NewPasswordScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isLoading } = useMutation((data) => communication?.changePassword(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success: ${data?.data?.message}`);
        navigate(`/login`);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  });

  const handleNewPassowrd = (data) => {
    const dataToSend = { ...data, userId };
    mutate(dataToSend);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="loginComponent">
        <div className="loginLeft">
          <div className="logoContainer">
            <img src={loginLogo} alt="MOIL Logo" />
            <h1>MOIL LIMITED</h1>
            <p>( A Government of India Enterprise )</p>
          </div>
        </div>

        <div className="loginRight">
          <div className="loginFormContainer">
            <div className="formHeader">
              <h2>New Password</h2>
              <p>
                <strong>Enter a new password</strong> <span>to reset the password on your account</span>
              </p>
            </div>

            <form
              className="d-flex flex-column gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(handleNewPassowrd)();
              }}
            >
              <LoginInputs
                placeholder={"Enter New Password"}
                icon={svgData?.lockIcon}
                type="password"
                register={{ ...register("newPassword", { required: "New Password is Required" }) }}
                errorMessage={errors?.newPassword}
                style={{ backgroundColor: "transparent" }}
              />
              <LoginInputs
                placeholder={"Enter Confirm Password"}
                icon={svgData?.lockIcon}
                type="password"
                register={{ ...register("confirmPassword", { required: "Confirm Password is Required" }) }}
                errorMessage={errors?.confirmPassword}
                style={{ backgroundColor: "transparent" }}
              />

              <div className="formLinks">
                <p
                  onClick={() => {
                    navigate(`/login?page=otp&userId=${userId}`);
                  }}
                >
                  Back?
                </p>
              </div>

              <ColorBtn
                text={"Reset Password"}
                bgColor="#2F3299"
                color="#fff"
                style={{
                  boxShadow: "0px 4px 4px 0px #00000040",
                  border: "none",
                  width: "100%",
                  padding: "12px",
                  borderRadius: "6px",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
